import PersonAndTeam from "@coworker/apprestructured/src/task-management/components/PersonAndTeam/PersonAndTeam";
import { ViewerFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/ViewerFragment";
import { useUserAndTeamStrings } from "./useUserAndTeamStrings";

export type UserAndTeamViewerFragmentConfigProps = {
  title: string;
  userIdField: string;
  teamIdField?: string;
  teamFromUser?: boolean;
};

type UserAndTeamViewerFragmentProps = {
  configProps: UserAndTeamViewerFragmentConfigProps;
  commonProps: ViewerFragmentCommonProps;
};

function UserAndTeamViewerFragment({
  configProps: { userIdField, teamIdField, teamFromUser, title },
  commonProps: { task },
}: UserAndTeamViewerFragmentProps) {
  const { user, team } = useUserAndTeamStrings({
    task,
    userIdField,
    teamIdField,
    teamFromUser,
  });

  return <PersonAndTeam title={title} user={user} team={team} />;
}

export default UserAndTeamViewerFragment;
